<template>
    <div class="modificationVip">
        <!--<img src="../../../assets/img/logo.png" alt="logo" class="logo">-->
        <md-tab-bar
                v-model="current"
                :items="items"
        />
        <div class="nameBox" v-if="current==1">
            <md-field>
                <md-input-item
                        title="姓名："
                        v-model="Name"
                        clearable
                ></md-input-item>
            </md-field>
            <div class="mbtn" @click="nameFn">修改会员姓名</div>
        </div>
        <div class="phonBox" v-else >
            <md-field>
                <md-input-item
                        title="手机号："
                        v-model="mPhone"
                        type="phone"
                        clearable
                >
                </md-input-item>
                <md-input-item
                        title="验证码："
                        v-model="securityCode"
                        type="digit"
                        clearable
                >
                    <div class="operatorNum" v-if="securityState" slot="right" >{{num}}s</div>
                    <div class="input-operator" @click="securityCodeFn" v-else slot="right" >获取验证码</div>
                </md-input-item>

            </md-field>
            <div class="mbtn" @click="phoneFn">修改会员手机号</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "modificationVip",
        data(){
            return {
                current: 1,
                items: [{name: 1, label: '修改用户名'}, {name: 2, label: '修改手机号'}],
                mPhone:'', //手机号
                securityCode:'', //验证码
                securityState:false, //验证码显示状态
                num:60, //验证码时间
                codeData:'', //用户信息
                wei:6,
                Name:'', //姓名
                userData:''
            }
        },
        mounted(){
            this.userData = JSON.parse(localStorage.getItem("userData"))
        },
        methods:{
            securityCodeFn() {//获取验证码
                //这里判断手机号是否存在
                let {mPhone} = this
                if (!(/^1[34578]\d{9}$/.test(mPhone))) {
                    this.UI.Toast.failed("手机号格式错误")
                    return
                }
                this.securityState = true
                this.stop = setInterval(() => {
                    if (this.num == 0) {
                        clearInterval(this.stop)
                        this.securityState = false
                        this.num = 60
                    } else {
                        this.num--
                    }
                }, 1000)

                let mes = new URLSearchParams()
                mes.append('phone', this.mPhone) //手机
                mes.append('id', this.userData.wxOpenId) //用户id
                mes.append('num', this.wei) //验证码位数
                this.$http.post('/system/base/securityCode/message', mes).then(({data}) => { //获取验证码
                    // console.log(data)
                    if(data.code != 200){
                         this.UI.Toast.failed("获取短信验证码失败")
                    }
                })
            },
            nameFn(){ //修改姓名
                if(this.Name == null){
                    this.UI.Toast.failed("请输入姓名")
                    return
                }else if(this.Name.length > 32){
                    this.UI.Toast.failed("用户名长度不能超过32位")
                    return
                }
                let dt = new URLSearchParams()
                dt.append('memberId', this.userData.id)
                dt.append('name', this.Name)
                this.$http.post('/sangto-wrm/vip/member/updateName', dt).then(({data})=>{
                    if(data.code == 200){
                        this.UI.Toast.succeed("修改成功")
                        this.Name = ''
                        let dt2 = new URLSearchParams()
                        dt2.append('openid',localStorage.getItem("openId"))
                        this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt2).then(({data})=>{ //使用openid获取会员信息
                            if(data.code == 200 && data.data != null){
                                // console.log(data.data)
                                let dataStr = JSON.stringify(data.data)
                                if(data.data.cardAccount){
                                    localStorage.setItem("login", '1')
                                }else{
                                    localStorage.setItem("login", '0')
                                }

                                localStorage.setItem("userData", dataStr)
                            }else{
                                this.UI.Toast.failed(data.message)
                            }
                        })
                    }
                })

            },
            phoneFn(){ //修改手机
                if(this.securityCode == null){
                    this.UI.Toast.failed("请输入短信验证码")
                    return
                }
                let dt = new URLSearchParams()
                dt.append('memberId', this.userData.id)
                dt.append('openid', this.userData.wxOpenId)
                dt.append('phone', this.mPhone)
                dt.append('msgCode', this.securityCode)
                this.$http.post('/sangto-wrm/vip/member/updatePhone',dt).then(({data})=>{
                    if(data.code == 200){
                        this.UI.Toast.succeed("修改成功")
                        this.securityCode=''
                        this.mPhone=''
                        let dt2 = new URLSearchParams()
                        dt2.append('openid',localStorage.getItem("openId"))
                        this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt2).then(({data})=>{ //使用openid获取会员信息
                            if(data.code == 200 && data.data != null){
                                // console.log(data.data)
                                let dataStr = JSON.stringify(data.data)
                                if(data.data.cardAccount){
                                    localStorage.setItem("login", '1')
                                }else{
                                    localStorage.setItem("login", '0')
                                }

                                localStorage.setItem("userData", dataStr)
                            }else{
                                this.UI.Toast.failed(data.message)
                            }
                        })
                    }else{
                        this.UI.Toast.failed(data.message)
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
.modificationVip{
    width: 100%;
    min-height: 100%;
    position: relative;
    /*display: flex;*/
    /*flex-direction: column;*/
    /*align-items: center;*/
    background-color: #fff;
    .logo{
        margin-top: 20px;
        width: 60%;
        height: 48px;
    }
    .operatorNum{
        margin-right: 11px;
        width: 60px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        color: #ea5a59;
        border-radius: 4px;
        font-size: 14px;
    }
    .input-operator{
        margin-right: 11px;
        width: 100px;
        height: 34px;
        background-color: #26a5ff;
        text-align: center;
        line-height: 34px;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
    }
    .mbtn{
        width: 80%;
        height: 40px;
        background-color:#2db7f5 ;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 6px;
        margin: 60px auto 0 auto;
    }
}
</style>
